import { axiosGet } from "../../Helpers";

export const loadJobSeekerDetails = async (id, setLoading) => {
  let apiResonse = await axiosGet(`user/getJobSeekerDetails/${id}`);
  // console.log("ApiResponse", apiResonse.data.data[0]);
  setLoading && setLoading(false);
  return apiResonse.data.data[0];
};
